import { userSettingsService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    currentUserSettings: null,
    loading: true,
    saving: false
  }
}

const actions = {
  unsubscribeFromWorkOrderUpdates ({ commit }, code) {
    return userSettingsService.unsubscribeFromWorkOrderUpdates(code)
      .then(data => {
        return data.result
      }).catch(error => {
        return Promise.reject(error)
      })
  },

  getCurrentUserSettings ({ commit }) {
    return userSettingsService.getCurrentUserSettings()
      .then(data => {
        commit('getCurrentUserSettingsSuccess', data.result)
        return data.result
      }).catch(error => {
        commit('getCurrentUserSettingsError', error)
        return Promise.reject(error)
      })
  },

  saveCurrentUserSettings ({ commit }, userSettings) {
    return userSettingsService.saveCurrentUserSettings(userSettings)
      .then(data => {
        commit('saveCurrentUserSettingsSuccess', data.result)
        return data.result
      }).catch(error => {
        return Promise.reject(error)
      })
  }
}

const mutations = {
  getCurrentUserSettingsSuccess (state, data) {
    state.all.currentUserSettings = data
    state.all.loading = false
  },

  getCurrentUserSettingsError (state, error) {
    state.all.loading = false
    if (error.status !== 403 && error.status !== 401) {
      Vue.prototype.$toast('Kunde inte hämta användarinställningar', 'error')
    }
  },

  saveCurrentUserSettingsSuccess (state) {
    state.all.loading = false
    Vue.prototype.$toast('Inställningar sparade', 'success')
  },

  saveCurrentUserSettingsError (state, error) {
    state.all.loading = false
    console.error(error)
    Vue.prototype.$toast('Kunde inte spara användarinställningar', 'error')
  }
}

export const userSettings = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/user-settings.module.js